export default {"src":"/auth/v1/_next/static/media/check.239ab54b.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};